'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = require('../../../components');
var _UserAuthenticationForm = require('../UserAuthenticationForm/UserAuthenticationForm');var _UserAuthenticationForm2 = _interopRequireDefault(_UserAuthenticationForm);

var _constants = require('../../../constants');

require('./UserAuthenticationBody.scss');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
var UserAuthenticationBody = function (_Component) {_inherits(UserAuthenticationBody, _Component);function UserAuthenticationBody() {var _temp, _this, _ret;_classCallCheck(this, UserAuthenticationBody);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleSelect = function (key) {_this.props.changeTab({ selectedTab: key });
    }, _temp), _possibleConstructorReturn(_this, _ret);}UserAuthenticationBody.prototype.

  render = function render() {
    return (
      _react2.default.createElement(_components.OMTabs, {
          defaultActiveTabKey: this.props.selectedTab,
          onSelect: this.handleSelect,
          className: 'userAuthenticationTabs' },

        _react2.default.createElement(_components.OMTab, { id: _constants.userAuthenticationTabs.NEW_ACCOUNT, title: '' + this.props.translate('newAccountTab', 'tabTitle') },
          _react2.default.createElement(_UserAuthenticationForm2.default, {
            locale: this.props.locale,
            translate: this.props.translate('newAccountTab'),
            rootTranslate: this.props.rootTranslate,
            typeTab: _constants.userAuthenticationTabs.NEW_ACCOUNT,
            authenticateUser: this.props.authenticateUser,
            userAuthentication: this.props.userAuthentication,
            validateEmail: this.props.validateEmail,
            validatePassword: this.props.validatePassword,
            validateLicenseNumber: this.props.validateLicenseNumber,
            validateCompanyName: this.props.validateCompanyName,
            emailIsValid: this.props.emailIsValid,
            passwordIsValid: this.props.passwordIsValid,
            licenseNumberIsValid: this.props.licenseNumberIsValid,
            companyNameIsValid: this.props.companyNameIsValid,
            formIsActive: this.props.selectedTab === _constants.userAuthenticationTabs.NEW_ACCOUNT,
            triggerPressEnter: this.props.triggerPressEnter,
            isMobile: this.props.isMobile,
            isRtl: this.props.isRtl })),



        _react2.default.createElement(_components.OMTab, { id: _constants.userAuthenticationTabs.SIGN_IN, title: '' + this.props.translate('signInTab', 'tabTitle') },
          _react2.default.createElement(_UserAuthenticationForm2.default, {
            locale: this.props.locale,
            forgotPassword: this.props.forgotPassword,
            translate: this.props.translate('signInTab'),
            typeTab: _constants.userAuthenticationTabs.SIGN_IN,
            authenticateUser: this.props.authenticateUser,
            userAuthentication: this.props.userAuthentication,
            validateEmail: this.props.validateEmail,
            validatePassword: this.props.validatePassword,
            phoneIsValid: this.props.phoneIsValid,
            checkPhone: this.props.checkPhone,
            authenticateUserByNumber: this.props.authenticateUserByNumber,
            emailIsValid: this.props.emailIsValid,
            passwordIsValid: this.props.passwordIsValid,
            formIsActive: this.props.selectedTab === _constants.userAuthenticationTabs.SIGN_IN,
            triggerPressEnter: this.props.triggerPressEnter,
            isMobile: this.props.isMobile,
            isRtl: this.props.isRtl,
            clearUserAuthentication: this.props.clearUserAuthentication }))));




  };return UserAuthenticationBody;}(_react.Component);exports.default = UserAuthenticationBody;


UserAuthenticationBody.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool,
  selectedTab: _propTypes2.default.number.isRequired,
  translate: _propTypes2.default.func,
  rootTranslate: _propTypes2.default.func,
  forgotPassword: _propTypes2.default.func,
  authenticateUser: _propTypes2.default.func,
  userAuthentication: _propTypes2.default.object,
  validateEmail: _propTypes2.default.func,
  validatePassword: _propTypes2.default.func,
  validateLicenseNumber: _propTypes2.default.func,
  emailIsValid: _propTypes2.default.bool,
  phoneIsValid: _propTypes2.default.bool,
  checkPhone: _propTypes2.default.func,
  authenticateUserByNumber: _propTypes2.default.func,
  passwordIsValid: _propTypes2.default.bool,
  licenseNumberIsValid: _propTypes2.default.bool,
  changeTab: _propTypes2.default.func,
  triggerPressEnter: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  validateCompanyName: _propTypes2.default.func,
  companyNameIsValid: _propTypes2.default.bool,
  clearUserAuthentication: _propTypes2.default.func };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UserAuthentication/UserAuthenticationBody/UserAuthenticationBody.js
// module id = 1239
// module chunks = 0